import React from 'react';
import style from "./NotFound.module.css"

const NotFound = () => {
  return (
    <div className={style.page__404}>
      
    </div>
  )
}

export default NotFound;